import type { MessageDescriptor } from 'react-intl';
import { messages } from '../messages';

const THEME_LABELS: Record<string, MessageDescriptor> = {
  STUDIO: messages.themeStudio,
  METAL: messages.themeMetal,
  CLAY: messages.themeClay,
  OUTDOOR: messages.themeOutdoor,
};

/** A theme the viewer has no words for is shown as the server named it. */
export const themeLabel = (theme: string): MessageDescriptor | null =>
  Object.hasOwn(THEME_LABELS, theme) ? THEME_LABELS[theme] : null;
